var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptopAndCoding12521(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 82.302 75.38 H 7.698 C 3.454 75.38 0 71.927 0 67.682 v -3.233 c 0 -0.553 0.448 -1 1 -1 h 32.003 c 0.552 0 1 0.447 1 1 v 2.857 h 21.994 v -2.857 c 0 -0.553 0.447 -1 1 -1 H 89 c 0.553 0 1 0.447 1 1 v 3.233 C 90 71.927 86.547 75.38 82.302 75.38 z M 2 65.448 v 2.233 c 0 3.142 2.556 5.698 5.698 5.698 h 74.604 c 3.142 0 5.698 -2.557 5.698 -5.698 v -2.233 H 57.997 v 2.857 c 0 0.553 -0.447 1 -1 1 H 33.003 c -0.552 0 -1 -0.447 -1 -1 v -2.857 H 2 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.914 65.448 c -0.553 0 -1 -0.447 -1 -1 V 17.907 c 0 -0.71 -0.577 -1.288 -1.287 -1.288 H 8.374 c -0.71 0 -1.288 0.578 -1.288 1.288 v 46.541 c 0 0.553 -0.448 1 -1 1 s -1 -0.447 -1 -1 V 17.907 c 0 -1.813 1.475 -3.288 3.288 -3.288 h 73.253 c 1.813 0 3.287 1.475 3.287 3.288 v 46.541 C 84.914 65.001 84.467 65.448 83.914 65.448 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.5 60.448 h -67 c -0.552 0 -1 -0.447 -1 -1 v -36.31 c 0 -1.712 1.393 -3.104 3.104 -3.104 h 62.791 c 1.712 0 3.104 1.393 3.104 3.104 v 36.31 C 79.5 60.001 79.053 60.448 78.5 60.448 z M 12.5 58.448 h 65 v -35.31 c 0 -0.609 -0.495 -1.104 -1.104 -1.104 H 13.604 c -0.609 0 -1.104 0.496 -1.104 1.104 V 58.448 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 53.5 c -7.444 0 -13.5 -6.056 -13.5 -13.5 c 0 -7.444 6.056 -13.5 13.5 -13.5 c 7.444 0 13.5 6.056 13.5 13.5 C 58.5 47.444 52.444 53.5 45 53.5 z M 45 28.5 c -6.341 0 -11.5 5.159 -11.5 11.5 c 0 6.341 5.159 11.5 11.5 11.5 c 6.341 0 11.5 -5.159 11.5 -11.5 C 56.5 33.659 51.341 28.5 45 28.5 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.296 43.875 c -0.256 0 -0.512 -0.098 -0.707 -0.293 l -2.634 -2.634 c -0.391 -0.391 -0.391 -1.023 0 -1.414 l 2.634 -2.634 c 0.391 -0.391 1.023 -0.391 1.414 0 s 0.391 1.023 0 1.414 l -1.927 1.927 l 1.927 1.927 c 0.391 0.391 0.391 1.024 0 1.414 C 40.808 43.778 40.552 43.875 40.296 43.875 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.703 43.875 c -0.256 0 -0.512 -0.098 -0.707 -0.293 c -0.391 -0.391 -0.391 -1.024 0 -1.414 l 1.928 -1.927 l -1.928 -1.927 c -0.391 -0.39 -0.391 -1.023 0 -1.414 s 1.023 -0.391 1.414 0 l 2.635 2.634 c 0.188 0.188 0.293 0.442 0.293 0.707 s -0.105 0.52 -0.293 0.707 l -2.635 2.634 C 50.215 43.778 49.959 43.875 49.703 43.875 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 43.29 45.768 c -0.118 0 -0.237 -0.021 -0.354 -0.065 c -0.517 -0.195 -0.777 -0.772 -0.582 -1.289 l 3.421 -9.051 c 0.196 -0.518 0.776 -0.776 1.289 -0.582 c 0.517 0.195 0.777 0.772 0.582 1.289 l -3.421 9.051 C 44.074 45.521 43.693 45.768 43.29 45.768 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopAndCoding12521);
export default __webpack_public_path__ + "static/media/laptop-and-coding-12521.6c5fd0a6e46014cfb3954747b8b5cc58.svg";
export { ForwardRef as ReactComponent };